import axios from "./index";
import { ERROR1, ERROR_500 } from "../constants";


export const getTeamMembers = async () => {
    try {
        const { data } = await axios({
            method: "GET",
            url: "/profile/team/members"
        });

        return {
            succeed: true,
            data: data.data
        };
    } catch (err) {
        let errMsg =
            err?.response?.data?.errorMessage ||
            ERROR1;

        if (err?.response?.data?.errorCode === ERROR_500) {
            errMsg =
                "There's something wrong retrieving the list of team members. Please try again later.";
        }
        return {
            succeed: false,
            message: errMsg
        };
    }
};


export const getMemberships = async () => {
    try {
        const { data } = await axios({
            method: "GET",
            url: "/profile/team/my/membership"
        });
        return {
            succeed: true,
            data: data.data
        };
    } catch (err) {
        let errMsg =
            err?.response?.data?.errorMessage ||
            ERROR1;

        if (err?.response?.data?.errorCode === ERROR_500) {
            errMsg =
                "There's something wrong retrieving the list of team memberships. Please try again later.";
        }
        return {
            succeed: false,
            message: errMsg
        };
    }
};


export const inviteTeamMember = async (member) => {
    try {
        const { data } = await axios({
            method: "POST",
            url: "/profile/team/member",
            data: member
        });
        return {
            succeed: true,
            message: "Invitation Sent.",
            data: data.data
        };
    } catch (err) {
        const errMsg =
            err?.response?.data?.errorMessage ||
            ERROR1;
        return {
            succeed: false,
            message: errMsg,
            data: {}
        };
    }
};


export const acceptMembership = async (agentSysGenId) => {
    try {
        const { data } = await axios({
            method: "POST",
            url: "/profile/team/member/approval/action",
            data: {
                    "agentSysGenId": agentSysGenId,
                    "isApprovedAction": true
                }
        });
        return {
            succeed: true,
            message: "Invitation Accepted",
            data: data.data
        };
    } catch (err) {
        const errMsg =
            err?.response?.data?.errorMessage ||
            ERROR1;
        return {
            succeed: false,
            message: errMsg,
            data: {}
        };
    }
}


export const declineMembership = async (agentSysGenId) => {
    try {
        const { data } = await axios({
            method: "POST",
            url: "/profile/team/member/approval/action",
            data: {
                    "agentSysGenId": agentSysGenId,
                    "isApprovedAction": false
                }
        });
        return {
            succeed: true,
            message: "Invitation Declined",
            data: data.data
        };
    } catch (err) {
        const errMsg =
            err?.response?.data?.errorMessage ||
            ERROR1;
        return {
            succeed: false,
            message: errMsg,
            data: {}
        };
    }
}


export const getPendingMembership = async () => {
    try {
        const { data } = await axios({
            method: "GET",
            url: "/profile/team/my/invite/pending"
        });
        return {
            succeed: true,
            data: data.data
        };
    } catch (err) {
        let errMsg =
            err?.response?.data?.errorMessage ||
            ERROR1;

        if (err?.response?.data?.errorCode === ERROR_500) {
            errMsg =
                "There's something wrong retrieving the list of pending members. Please try again later.";
        }
        return {
            succeed: false,
            message: errMsg
        };
    }
}


export const revokeTeamMember = async (memberId) => {
    try {
        await axios({
            method: "DELETE",
            url: `/profile/team/member/revoke/${memberId}`
        });
        return {
            succeed: true,
            message: "Team member's access has been successfully revoked."
        };
    } catch (err) {
        const errMsg =
            err?.response?.data?.errorMessage ||
            ERROR1;

        return {
            succeed: false,
            message: errMsg
        };
    }
};


export const reinviteTeamMember = async (memberId) => {
    try {
        await axios({
            method: "GET",
            url: `/profile/team/member/resend/${memberId}`
        });
        return {
            succeed: true,
            message: "Invitation is resent."
        };
    } catch (err) {
        const errMsg =
            err?.response?.data?.errorMessage ||
            ERROR1;
        return {
            succeed: false,
            message: errMsg
        };
    }
};


export const removeFromTeam = async (memberId) => {
    try {
        await axios({
            method: "DELETE",
            url: `/profile/team/my/remove/${memberId}`
        });
        return {
            succeed: true,
            message: "You have been successfully removed."
        };
    } catch (err) {
        const errMsg =
            err?.response?.data?.errorMessage ||
            ERROR1;

        return {
            succeed: false,
            message: errMsg
        };
    }
};